// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3rvFA","validationTips":"StatementDescriptor_validationTips__2flfm"};